import React from 'react'

const LABELS = {
  online: 'Gateway: Sync',
  local_only: 'Gateway: Solo Local',
  disconnected: 'Gateway: Desconectado',
  update_udv: 'Gateway: Update UDV',
}

const VARIANT = {
  online: 'is-online',
  local_only: 'is-local',
  disconnected: 'is-disconnected',
  update_udv: 'is-update',
}

/**
 * Chip de estado Gateway (online | local_only | disconnected | update_udv).
 * @param {{
 *   status?: string,
 *   compatOk?: boolean,
 *   onClick?: () => void,
 *   className?: string,
 *   style?: object,
 *   labels?: object,
 * }} props
 */
export default function GatewayStatusBadge({
  status = 'local_only',
  compatOk,
  onClick,
  className = '',
  style,
  labels,
}) {
  let key =
    status === 'online' || status === 'disconnected' ? status : 'local_only'
  if (compatOk === false && key !== 'disconnected') {
    key = 'update_udv'
  }
  const label = (labels && labels[key]) || LABELS[key]
  const variant = VARIANT[key]
  const classes = ['udv-gateway-status-badge', variant, className]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type="button"
      className={classes}
      style={style}
      onClick={typeof onClick === 'function' ? onClick : undefined}
      aria-label={label}
      title={label}
    >
      {label}
    </button>
  )
}
